import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Activity, WifiOff } from 'lucide-react';
import { EventActorList } from '../../components/modules/AuthActivity/EventActorList/EventActorList';
// import Pagination from '../../components/modules/AuthActivity/Pagination/Pagination';
import Pagination from "../../components/common/Pagination/Pagination";
import { itdrApi, getToken } from '../../services/api';
import {
  setSseLoading,
  setSseConnectionStatus,
  addSseEvent,
  setSsePage,
  resetSseState,
} from '../../store/slices/authActivitySlice';
import {
  selectPaginatedSseEvents,
  selectSsePaginationInfo,
} from '../../store/selectors/authActivitySelectors';
import './AuthActivityPage.css';

export const RealTimeComponent = () => {
  const dispatch = useDispatch();

  // Get data from Redux
  const paginatedData = useSelector(selectPaginatedSseEvents);
  const paginationInfo = useSelector(selectSsePaginationInfo);
  const { loading, connectionStatus } = useSelector((state) => state.authActivity.sseData);
  const totalEvents = useSelector((state) => state.authActivity.sseData.events.length);

  // Initialize SSE connection
  useEffect(() => {
    const token = getToken();
    const baseURL = itdrApi?.defaults?.baseURL || "";

    dispatch(setSseLoading(true));
    dispatch(setSseConnectionStatus('connecting'));

    const eventSource = new EventSource(`${baseURL}/live-events-stream?token=${token}`);


    eventSource.onopen = () => {
      // console.log('SSE Connection opened');
      dispatch(setSseConnectionStatus('connected'));
      dispatch(setSseLoading(false));
    };

   eventSource.onmessage = (event) => {
      try {
        const parsedData = JSON.parse(event.data);
        
        // 2. Data has arrived: Stop loading and update state
        dispatch(setSseLoading(false));
        dispatch(setSseConnectionStatus('connected'));
        dispatch(addSseEvent(parsedData));
      } catch (err) {
        console.error('Error parsing SSE data:', err);
      }
    };

    eventSource.onerror = (error) => {
      console.error('SSE Connection Error:', error);
      // Only stop loading if we actually hit an error
      dispatch(setSseLoading(false));
      dispatch(setSseConnectionStatus('error'));
    };
    return () => {
      // 3. Cleanup: Close stream when component leaves screen
      eventSource.close();
      // We don't dispatch disconnected here to prevent a flicker 
      // if the component re-renders quickly
    };
  }, [dispatch]);

  // Handle page change
  const handlePageChange = (newPage) => {
    dispatch(setSsePage(newPage));
  };


  if (loading) {
    return (
      <div className="loader-container">
        <div className="modern-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
        <div className="loader-content">
          <h3>Monitoring live events...</h3>
          <p>{connectionStatus === 'connecting' ? 'Establishing connection...' : 'Waiting for incoming data...'}</p>
        </div>
      </div>
    );
  }


  // Events list with pagination
  return (
    <div className="sse-container">
      <div className="sse-header">
        <h3 className="sse-title">
          <Activity size={20} />
          Live Updates
        </h3>
        <div className="sse-meta">
          {/* <span className="event-counter">
            {totalEvents} {totalEvents === 1 ? 'event' : 'events'}
          </span> */}
          <div className={`connection-badge ${connectionStatus}`}>
            {connectionStatus === 'connected' ? (
              <>
                <Activity size={14} /> Connected
              </>
            ) : connectionStatus === 'error' ? (
              <>
                <WifiOff size={14} />
                 Disconnected
              </>
            ) : (
              <>
                {/* <WifiOff size={14} /> {connectionStatus} */}
              </>
            )}
          </div>
        </div>
      </div>

      {totalEvents === 0 ? (
        <div className="no-events">
          <div className="no-events-icon">
            <Activity size={48} />
          </div>
          <h4>No live events yet</h4>
          <p>Listening for authentication activity in real-time...</p>
        </div>
      ) : (
        <>
          <div className="event-list">
            {paginatedData.map((item, index) => (
              <EventActorList 
                key={item?.id || `sse-event-${index}`} 
                events={[item]} 
              />
            ))}
          </div>

          {paginationInfo.totalPages > 1 && (
            <div style={{ marginTop: '24px' }}>
              <Pagination
                currentPage={paginationInfo.page}
                totalPages={paginationInfo.totalPages}
                totalItems={paginationInfo.totalCount}
                itemsPerPage={paginationInfo.pageSize}
                onPageChange={handlePageChange}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};